import React from "react";

import Paragraph from '../../Paragraph/Paragraph';
import SharingPicture from "../SharingPicture/SharingPicture";
import styles from "./Sharing.module.scss";

export default function Sharing() {
  return (
    <div>
      <div className={styles['sharing-container']}>
        <Paragraph
          title="Bạn có thể chia sẻ một chút về những thành tựu mà PipFarm đã đạt được gần đây không?"
          content={[
            'Khi công ty vừa tròn sáu tháng, hơn 10,000 nhà giao dịch trên toàn thế giới đã tham gia PipFarm, và chúng tôi đã trả cho các nhà giao dịch hơn 600,000 USD lợi nhuận. Chúng tôi nhanh chóng xây dựng được danh tiếng mạnh mẽ trong việc coi nhà giao dịch là đồng nghiệp thay vì chỉ là khách hàng. Có hơn 4,000 nhà giao dịch tham gia cộng đồng Discord của chúng tôi, và với sự hỗ trợ từ các đồng nghiệp mới tại Việt Nam, chúng tôi đang ra mắt cộng đồng Việt Nam.',
          ]}
        />
      </div>
      <SharingPicture />
    </div>
  );
}
